import loglevel from 'loglevel';

import { ConfigStore } from '@sureinc/atlas-common/config';

const envLogLevel = import.meta.env.VITE_LOG_LEVEL;

loglevel.setDefaultLevel(
  envLogLevel
    ? envLogLevel
    : ConfigStore.config.environment === 'production'
      ? loglevel.levels.WARN
      : loglevel.levels.DEBUG
);

export default loglevel;
